export default (state = {}, action) => {

    switch (action.type) {

        case 'SET_DATA_PUBLIC':
            return {
                ...state,
                dataPublic: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/dataPublicReducer.js